import {useUserStore} from '@/providers/userProvider'

export const useGetMenuItems = () => {
  const {user} = useUserStore()
  const isAdmin = user?.role === 'ROLE_ADMIN'

  const authPages = [
    {
      name: 'Ordens',
      href: '/ordens/',
    },
  ]
  const adminPages = [
    {
      name: 'Cadastros',
      href: '/cadastros/',
    },
  ]
  return [...(user ? authPages : []), ...(isAdmin ? adminPages : [])]
}
